import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import { getClaimStatusesApi } from 'api/claimStatuses';
import { RequestQueryKeysE } from 'declarations/enums/react-query';
import type { ClaimStatusI } from 'declarations/interfaces/claimStatuses';
import type { ApiErrorI } from 'declarations/interfaces/errors';

type ClaimStatusRequestT = {
  isEnabled: boolean;
  roofTopId: string | undefined;
};

export const useFetchClaimStatuses = (
  params: ClaimStatusRequestT
): UseQueryResult<ClaimStatusI[], ApiErrorI> =>
  useQuery<ClaimStatusI[], ApiErrorI>(
    [RequestQueryKeysE.FetchClaimStatuses, params.roofTopId],
    () => getClaimStatusesApi(params.roofTopId || ''),
    { enabled: params.isEnabled }
  );
